export default {
    importAll (r: any) {
        let images: any = [];
        r.keys().map((item: any, index: number) => { images[index] = r(item) });
        return images;
    }
}